import * as React from 'react';

import ProgramEditForm from '../../components/program/program-edit-form';

const EditProgram: React.FC<{ match: { params: { orgId; programId } } }> = ({ match }) => {
  const { orgId, programId } = match.params;

  return (
    <div id="new-program" className="container">
      <div className="u-xs-padMd u-sm-spaceTopLg u-flexExpandSides">
        <ProgramEditForm programId={+programId} organizationId={+orgId} />
      </div>
    </div>
  );
};

export default EditProgram;
